import { StepUpTransactionServiceClient } from 'pbts/c1/api/stepup/v1/stepup.client'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

// Search Step Up Transactions
export const searchStepUpTransactionsApi = createPagedListApi(
    StepUpTransactionServiceClient,
    'search',
)

// Get a single Step Up Transaction
export const getStepUpTransactionApi = createUnaryApi(
    StepUpTransactionServiceClient,
    'get',
)
